<style>
    .activity-log-form {
        font-size: .9rem;
    }
    .activity-log-form .card-header h4,
    .activity-log-form .card.card-success .card-header h4 {
        height: 60px;
        font-weight: 300;
        font-size: 20pt;
        letter-spacing: 2px;
        padding: auto;
    }

    #main_content .activity-log-form select,
    #main_content .activity-log-form input[type=text],
    #main_content .activity-log-form input[type=date],
    #main_content .activity-log-form textarea {
        font-size: 12px !important;
        height: 40px !important;
        padding-left: 1em;
    }
    #main_content .activity-log-form textarea {
        height: inherit !important;
    }
    #main_content .activity-log-form p {
        font-weight: bold;
        color: #223264;
        font-size: 15px;
        margin: 7px 0 0 0;
    }
</style>

<template>
    <div id="activityLogFormModal" ref="createEditModal" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="card-deck"> 
                        <div class="card card-success mb-6"> 
                            <div class="card-header bg-success text-center">
                                <div class="pull-right">
                                    <button type="button" aria-label="Close" class="close" data-dismiss="modal">&times;</button>
                                </div>
                                <h4 class="my-0">
                                {{title}} TA Activity
                                </h4> 
                            </div> 
                            <div class="card-body">
                                <form action="consultants/activity-log/store" method="POST" id="activity-log-form">
                                    <p>Record TA Activity for this program.</p>
                                    <div class="row">
                                        <div class="col">
                                            <div class="form-group">
                                                <label for="date">Date</label>
                                                <input type="date" 
                                                    :max="currentDate"
                                                    v-model="currentLog.date" 
                                                    class="form-control"
                                                />
                                                <error-message v-if="hasError('date')" :errors="error.date"></error-message>
                                            </div>
                                        </div>
                                        <div class="col">
                                            <div class="form-group">
                                                <label for="activity">Activity Type</label>
                                                <select class="form-control" id="activity_log_type_id" name="activity_log_type_id" v-model="currentLog.activity_log_type_id" v-show="typeOptions.length > 0">
                                                    <option value="" selected>Select Type</option>
                                                    <option v-for="aType in typeOptions" :key="aType.id" :value="aType.id">{{aType.name}}</option>
                                                </select>
                                                <div  v-show="typeOptions.length == 0">Loading types...</div>
                                                <error-message v-if="hasError('type')" :errors="error.type"></error-message>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-6">
                                            <div class="form-group">
                                                <label for="hours">Please enter your time spent:</label>
                                                <div class="row">
                                                    <div class="col-6">
                                                        <select class="form-control" name="hours" id="hours" v-model="currentLog.hours">
                                                            <option value="" selected>Hours</option>
                                                            <option value="0">0 Hours</option>
                                                            <option value="1">1 Hour</option>
                                                            <option value="2">2 Hours</option>
                                                            <option value="3">3 Hours</option>
                                                            <option value="4">4 Hours</option>
                                                            <option value="5">5 Hours</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-6">
                                                        <select class="form-control" name="minutes" id="minutes" v-model="currentLog.minutes">
                                                            <option value="" selected>Minutes</option>
                                                            <option value="0">0 Minutes</option>
                                                            <option value="5">5 Minutes</option>
                                                            <option value="10">10 Minutes</option>
                                                            <option value="15">15 Minutes</option>
                                                            <option value="20">20 Minutes</option>
                                                            <option value="25">25 Minutes</option>
                                                            <option value="30">30 Minutes</option>
                                                            <option value="35">35 Minutes</option>
                                                            <option value="40">40 Minutes</option>
                                                            <option value="45">45 Minutes</option>
                                                            <option value="50">50 Minutes</option>
                                                            <option value="55">55 Minutes</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <error-message v-if="hasError('hours') || hasError('minutes')" :errors="[].concat(error.hours, error.minutes)"></error-message>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                        <label for="">Please select all areas that apply for this activity:</label>
                                            <error-message v-if="hasError('areas')" :errors="error.areas"></error-message>
                                            <div  v-show="areaOptions.length == 0" class="alert">Loading areas...</div>
                                            <div class="row" v-show="areaOptions.length > 0">
                                                <div class="col">
                                                    <template v-for="area in areaOptions">
                                                        <div class="form-check" :key="area.id" v-if="area.sort % 2 == 0">
                                                            <input class="form-check-input" type="checkbox" v-bind:id="'area-' + area.id" name="areas[]" v-bind:value="area.id" v-model="currentLog.areaIds">
                                                            <label class="form-check-label" v-bind:for="'area-' + area.id">{{area.name}}</label>
                                                        </div>
                                                    </template>
                                                </div>
                                                <div class="col">
                                                    <template v-for="area in areaOptions">
                                                        <div class="form-check" :key="area.id" v-if="area.sort % 2 !== 0">
                                                            <input class="form-check-input" type="checkbox" v-bind:id="'area-' + area.id" name="areas[]" v-bind:value="area.id" v-model="currentLog.areaIds">
                                                            <label class="form-check-label" v-bind:for="'area-' + area.id">{{area.name}}</label>
                                                        </div>
                                                    </template>
                                                </div>
                                            </div>
                                            <div v-show="currentLog.areaIds.indexOf(15) > -1">
                                                <label for="areas-other-detail">Please specify other step/content</label>
                                                <input id="areas-other-detail" type="text" v-model="currentLog.areas_other_details" class="form-control">
                                                <error-message v-if="hasError('areas_other_details')" :errors="error.areas_other_details"></error-message>                    
                                            </div>
                                            <div class="row" v-if="currentLog.areaIds.includes('14') || currentLog.areaIds.includes(14)">
                                                <div class="col">
                                                    <label for="staffTrained">Number of Staff Trained</label>
                                                    <input type="number" class="form-control" name="staffTrained" id="staffTrained" v-model="currentLog.staffTrained"/>
                                                    <error-message v-if="hasError('staff_trained')" :errors="error.staff_trained"></error-message>
                                                </div>
                                                <div class="col">
                                                    <label for="parentsTrained">Number of Parents Trained</label>
                                                    <input type="number" class="form-control" name="parentsTrained" id="parentsTrained" v-model="currentLog.parentsTrained"/>
                                                    <error-message v-if="hasError('parents_trained')" :errors="error.parents_trained"></error-message>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <label for="notes">Notes:</label>
                                            <textarea name="notes" id="notes" rows='3' class="form-control" v-model="currentLog.notes"></textarea>
                                            <error-message v-if="hasError('notes')" :errors="error.notes"></error-message>
                                        </div>
                                    </div>
                                </form>
                                <br />
                                <div class="text-left">
                                    <button type="button" class="btn btn-orange-blue" v-on:click="validate" :disabled="submitting">
                                        {{submitting ? 'Saving...' : 'Save'}}
                                    </button>
                                    <button @click="closeModal('activityLogFormModal')">Close</button>
                                </div>
                            </div> 
                        </div> 
                    </div> 
                </div> 
            </div> 
        </div> 
    </div>
</template>

<script>
    import ErrorMessage from '../ErrorMessage'
    import moment from 'moment'
    import { mapWritableState, mapActions } from 'pinia'
    import { useConsultantsStore } from './store.js';

    export default {
        components: {
            ErrorMessage,
        },
        props: {
            log: {
                type: Object
            },
            title: {
                type: String,
                default: 'Add'
            },
            logAreas: {
                type: Array,
                default: () => {
                    return []
                }
            },
            types: {
                type: Array,
                default: () => {
                    return []
                }
            },
            program: {
                required: true,
                type: Object
            },
        },
        data() {
            return {
                areaOptions: this.logAreas,
                error: null,
                errors: [],
                modalTitle: "Add",
                typeOptions: [],
                submitting: false,
            }
        },
        methods: {
        	validate: function(e){
        		this.errors = [];
                this.submit();
        	},
        	submit(){
                if(this.currentLog.id){
                    var url = '/api/activity-log/edit/'+this.currentLog.id
                }else{
                    var url = '/api/activity-log/store'
                }
                let data = {
                    type: this.currentLog.activity_log_type_id,
                    date: this.currentLog.date,
                    hours: this.currentLog.hours,
                    minutes: this.currentLog.minutes,
                    areas: this.currentLog.areaIds,
                    program_id : this.program.id,
                    notes: this.currentLog.notes,
                    areas_other_details: this.currentLog.areas_other_details
                }
                
                if (this.currentLog.areaIds.indexOf(14) > -1) {
                    data.staff_trained = this.currentLog.staffTrained
                    data.parents_trained = this.currentLog.parentsTrained
                }

                this.submitting = true;
        		axios.post(url, data)
                    .then(response => {
                        this.submitting = false;
                        this.closeModal("activityLogFormModal");
                        this.clearForm()
                    })
                    .catch(error => {
                        this.submitting = false;
                        this.error = error.response.data.errors
                    })
            },
            hasError(field) {
                if (!this.error) {
                    return false;
                }
                return Object.keys(this.error).indexOf(field) > -1;
            },
            clearForm(){
                this.resetCurrentLog();
            },
            closeModal(modalId) {
                $('#'+modalId).modal('hide');
            },
            ...mapActions(useConsultantsStore, {
                resetCurrentLog: 'resetLog',
            })
        },
        computed: {
            currentDate() {
                return moment().format('YYYY-MM-DD');
            },
            ...mapWritableState(useConsultantsStore, {
                currentLog: 'log',
                logs: 'logs'
            }),
        },
        watch: {
            currentLog(to, from) {
                this.currentLog.date = moment(to.date).format('YYYY-MM-DD')
                this.currentLog.hours = Math.floor(to.time_spent / 60);
                this.currentLog.minutes = to.time_spent % 60;
            }
        },
        mounted() {
            this.typeOptions = this.types;
            if (this.types.length == 0) {
                window.axios.get('/api/activity_log_types')
                    .then(response => {
                        this.typeOptions = response.data
                    }).catch(error => {
                    })
            }
            if (this.logAreas.length == 0) {
                window.axios.get('/api/activity_log_areas')
                    .then(response => {
                        this.areaOptions = response.data
                    }).catch(error => {
                    })
            }

            if(this.log) {
                this.currentLog = this.log;
            }
        }
}
</script>
